module.exports = __webpack_public_path__ + "static/media/re_sustainability.057788e5.svg";